/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Bannermessage3Inputs */

const en_coinvestments_declinedeal_bannermessage3 = /** @type {(inputs: Coinvestments_Declinedeal_Bannermessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This opportunity has been declined`)
};

/**
* | output |
* | --- |
* | "This opportunity has been declined" |
*
* @param {Coinvestments_Declinedeal_Bannermessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_bannermessage3 = /** @type {((inputs?: Coinvestments_Declinedeal_Bannermessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Bannermessage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_bannermessage3(inputs)
});
export { coinvestments_declinedeal_bannermessage3 as "coInvestments_declineDeal_bannerMessage" }